module.exports = __webpack_public_path__ + "static/media/clear.b04b3c75.svg";